const DRAWER_WIDTH = 330

export {
  DRAWER_WIDTH,
  
}